import { createContext } from 'react';
import ContextPropsType from './ContextPropTypes';
import config from './config';

export default createContext<ContextPropsType>(config);
